import React from 'react';

const Spinner = () => {
  return <img className="spinner-img" src={'../../../../img/spinner.gif'} />;
};

export default Spinner;
